<div
    role="dialog"
    class ="agpr-targetingRhpTakeover-overlay"
    [ngClass]="{'agpr-targetingRhpTakeover-overlay--fullHeight': fullHeight}"
    [@overlayAnimation]="overlayAnimation"
    (@overlayAnimation.done)="animationDone($event)"
    [ngStyle]="{'z-index': zIndex}"
    tabindex="0"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [attr.aria-modal]="true"
    [attr.aria-label]="dialogLabel"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        class="agpr-targetingRhpTakeover-greyout"
        (click)="close()"
    >
        <agpr-button
            class="agpr-targetingRhpTakeover-focusClose"
            [style]="buttonTypes.icon"
            icon="agpr-i-close"
            tooltip="close"
            tooltipPosition="top"
            (click)="close()"
        ></agpr-button>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    <aside
        class="agpr-targetingRhpTakeover-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-rhp-contexts
            [id]="key + '_rhpContext'"
            [disableContentToggle]="disableContentToggle"
            [fullHeightTakeover]="fullHeight"
        >
            <!-- TO DO: Private Contacts 'eye tab' to be added in future release -->
            <!-- <agpr-tab
                icon='fa-regular fa-eye'
                tooltip="A dummy tab for proof of concept"
            ></agpr-tab> -->
        </agpr-rhp-contexts>
    </aside>
</div>
